import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7595e466")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "p-mb-3" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = { class: "p-my-0" }
const _hoisted_5 = {
  key: 0,
  class: "p-field type"
}
const _hoisted_6 = { class: "p-field name" }
const _hoisted_7 = { class: "p-inputgroup" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" })
], -1)
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = { class: "p-inputgroup" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone" })
], -1)
const _hoisted_12 = { class: "p-field p-fluid" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = { for: "note" }
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("small", { class: "p-ml-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }),
  /*#__PURE__*/_createTextVNode(" Il risultato della ricerca verrà applicato ai campi sottostanti. ")
], -1)
const _hoisted_17 = { class: "picker_form_group" }
const _hoisted_18 = { class: "p-field" }
const _hoisted_19 = { class: "p-inputgroup" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map" })
], -1)
const _hoisted_21 = { class: "p-field" }
const _hoisted_22 = { class: "p-inputgroup" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map" })
], -1)
const _hoisted_24 = { class: "picker_form_group" }
const _hoisted_25 = { class: "p-field" }
const _hoisted_26 = { class: "p-inputgroup" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map" })
], -1)
const _hoisted_28 = { class: "p-field" }
const _hoisted_29 = { class: "p-inputgroup" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map" })
], -1)
const _hoisted_31 = {
  key: 0,
  class: "p-my-2"
}
const _hoisted_32 = { class: "p-text-center" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { id: "pickerMap" }, null, -1)
const _hoisted_34 = { class: "actions" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_AddressAutocomplete = _resolveComponent("AddressAutocomplete")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, {
    ref: "sidebar",
    position: "right",
    class: "p-sidebar-lg custom_sidebar",
    onShow: _ctx.onShow,
    onHide: _ctx.onHide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            (_ctx.isPickup)
              ? (_openBlock(), _createBlock(_component_FaIcon, {
                  key: 0,
                  icon: "caret-square-up",
                  class: "p-mr-3"
                }))
              : _createCommentVNode("", true),
            (_ctx.isDropoff)
              ? (_openBlock(), _createBlock(_component_FaIcon, {
                  key: 1,
                  icon: "caret-square-down",
                  class: "p-mr-3"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1)
          ])
        ]),
        _createElementVNode("form", {
          id: "picker_form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
          class: "picker_form_group"
        }, [
          (!_ctx.pickerType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_SelectButton, {
                  modelValue: _ctx.type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.type = $event)),
                  options: _ctx.typeOptions,
                  optionLabel: "name",
                  optionValue: "value"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_FloatLabel, { label: "Nome" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.picker.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.picker.name = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ])
        ], 32),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_FloatLabel, { label: "Telefono" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.picker.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.picker.phone = $event)),
                  maxlength: "15"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, [
            _createVNode(_component_Textarea, {
              id: "note",
              autoResize: true,
              rows: "5",
              cols: "30",
              modelValue: _ctx.picker.note,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.picker.note = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('entity.note')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_AddressAutocomplete, {
            modelValue: _ctx.autocompleteAddress,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.autocompleteAddress = $event)),
            onSelectedAddress: _ctx.onSelectAddress
          }, null, 8, ["modelValue", "onSelectedAddress"]),
          _hoisted_16
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_FloatLabel, { label: "Indirizzo" }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.picker.address,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.picker.address = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_FloatLabel, {
                label: "Città",
                class: "p-fluid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.picker.city_name,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.picker.city_name = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_FloatLabel, {
                label: "Provincia",
                class: "p-fluid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.picker.province,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.picker.province = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_FloatLabel, {
                label: "CAP",
                class: "p-fluid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.picker.postal_code,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.picker.postal_code = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        ((_ctx.zone && _ctx.isServed === false) || _ctx.errorOnSave)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createVNode(_component_Message, {
                class: "p-text-center",
                severity: "error"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.msg), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_Button, {
            label: _ctx.$t('cancel'),
            class: "p-button-secondary",
            icon: "pi pi-times",
            onClick: _ctx.close
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            form: "picker_form",
            type: "submit",
            label: _ctx.$t('common.save'),
            icon: "pi pi-save"
          }, null, 8, ["label"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onShow", "onHide"]))
}